import { h } from 'preact';
import style from './style';

export const VerticalBarGraph = ({ width, height, bars, ...props }) => {
	let barWidth = width / bars.length;
	return (
		<div class={`${style['bar-graph']} ${style['vertical-bar-graph']}`}>
			<svg width="100%" viewBox={'0 0 ' + width + ' ' + height}>
				<g class={style.bars}>
					{ bars.map((row,i) => (
						<VerticalBarGraphBar {...{ ...bars[i], width: barWidth, height,i, ...props }} />
					)) }
				</g>
			</svg>
		</div>
	);
};

const VerticalBarGraphBar = ({ i,value, barLabel, valLabel, width, height, className,padding = 1, barStartValue = 0 }) => {

	let labelHeight = barLabel ? 25 : 0;
	let barMax = height - labelHeight;

	let barPos = (value * barMax);
	let barStart = (barStartValue * barMax);

	let valHeight = 25;
	let labelInside = false;
	let labelPos;
	if (barPos > barStart) { //Upward bar
		if (barMax - barPos > valHeight) {
			labelPos = barPos + 5;
		}
		else if (barPos - barStart > valHeight) {
			labelPos = barPos - 12;
			labelInside = true;
		}
		else {
			labelPos = barStart - 12;
		}
	}
	else if (barPos > valHeight) {
		labelPos = barPos - 12;
	}
	else if (barStart - barPos > valHeight) {
		labelPos = barPos + 5;
		labelInside = true;
	}
	else {
		labelPos = barStart + 5;
	}


	return (
		<g class={style.barGroup + ' ' + (className || '')} transform={'translate(' + (width * i) + ',0)'}>
			<rect class={style.bg} x={padding} width={width - padding - padding} y={labelHeight} height={barMax} />
			<rect class={style.bar} x={padding} width={width - padding - padding} y={height - ( barStart > barPos ? barStart : barPos )} height={Math.abs(barStart - barPos)} />
			{ valLabel && (
				<text class={style.value + ' ' + (style[labelInside ? 'inside' : 'outside'])} x={width / 2} y={height - labelPos} text-anchor="middle">{ valLabel }</text>
			) }
			{ barLabel && (
				<text class={style.label} x={width / 2} y={labelHeight / 2} dominant-baseline="central" text-anchor="middle">{ barLabel }</text>
			) }
		</g>
	);
};

export const HorizontalBarGraph = ({ width, height, bars, ...props }) => {
	let barHeight = height / bars.length;
	return (
		<div class={`${style['bar-graph']} ${style['horizontal-bar-graph']}`}>
			<svg width="100%" viewBox={'0 0 ' + width + ' ' + height}>
				<g class={style.bars}>
					{ bars.map((row,i) => (
						<HorizontalBarGraphBar {...{ ...bars[i], height: barHeight, width, i, ...props }} />
					)) }
				</g>
			</svg>
		</div>
	);
};

const HorizontalBarGraphBar = ({ i,value, barLabel, valLabel, width, height, className,padding = 3, labelHeight = height * .5, labelPos = 'top', labelWidth = width * .2, barStartValue = 0.5 }) => {
	let barTop = labelPos === 'top' ? labelHeight + padding : 0;
	let barLeft = labelPos === 'left' ? labelWidth + padding : 0;
	let barHeight = height - barTop - padding;

	let barMax = width - barLeft;
	let barPos = (value * barMax);
	let barStart = (barStartValue * barMax);

	let valWidth = 20;
	let labelInside = false;
	let labelLeft = true;
	let labelX;
	if (barPos > barStart) { //Rightward bar
		if (barMax - barPos > valWidth) {
			labelX = barPos;
		}
		else if (barPos - barStart > valWidth) {
			labelX = barPos;
			labelInside = true;
			labelLeft = false;
		}
		else {
			labelX = barStart;
			labelLeft = false;
		}
	}
	else if (barPos > valWidth) {
		labelX = barPos;
		labelLeft = false;
	}
	else if (barStart - barPos > valWidth) {
		 labelX = barPos;
		labelInside = true;
	}
	else {
		labelX = barStart;
	}


	return (
		<g class={style.barGroup + ' ' + (style[className] || '')} transform={'translate(0,' + (height * i) + ')'}>
			<rect class={style.bg} x={barLeft} y={barTop} width={barMax} height={barHeight} />
			<rect class={style.bar} x={barLeft + (barStart < barPos ? barStart : barPos)} y={barTop} width={Math.abs(barStart - barPos)} height={barHeight} />
			{ valLabel && (
				<text class={style.value + ' ' + style[labelInside ? 'inside' : 'outside']} x={barLeft + labelX + (labelLeft ? 2 : -2)} y={barTop + (barHeight / 2)} dominant-baseline="central" text-anchor={labelLeft ? 'start' : 'end'}>{ valLabel }</text>
			) }
			{ barLabel && (
				{
					top: <text class={style.label} x={5} y={labelHeight / 2} dominant-baseline="central" text-anchor="left">{ barLabel }</text>,
					left: <text class={style.label} x={0} y={height / 2} dominant-baseline="central" text-anchor="start">{ barLabel }</text>
				}[labelPos]
			) }
		</g>
	);
};
